import { useContext } from "react";

import { ClickContext } from "./__internal__/BrandTileImpressionContexts";

export const useBrandTileClickImpression = ({
  brandToken = "",
  impressionId = "",
}: {
  brandToken?: string;
  impressionId?: string;
}) => {
  const { onLeftClick, onMiddleClick, onRightClick } = useContext(ClickContext);
  return {
    onLeftClick: () => onLeftClick?.({ brandToken, impressionId }),
    onMiddleClick: () => onMiddleClick?.({ brandToken, impressionId }),
    onRightClick: () => onRightClick?.({ brandToken, impressionId }),
  };
};
